import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/authContext'; // Import your auth context
import DialogConfirmation from './dialogs/DialogConfirmation';
import Layout from './Layout'
import { useAtom } from 'jotai';
import { userAtom } from '../store';

const PrivateRoute = ({ element, requireMembership = false }) => {
    const [userData, setUserData] = useAtom(userAtom)
    const storedUserData = localStorage.getItem('userData')

    useEffect(() => {
        if (storedUserData) {
            setUserData(JSON.parse(storedUserData))
        }
    }, [])

    // if (loading) {
    //     return <DialogConfirmation
    //         open={loading}
    //         onClose={() => { }}
    //         type="loading"
    //         title="Please wait"
    //         message="We are processing your booking request. Please wait and don’t close this page"
    //         buttonText="Cancel"
    //         onButtonClick={
    //             () => { }
    //         }
    //     />
    // }

    if (!storedUserData) {
        return <Navigate to="/login" replace={true} />
    }

    if (!userData) {
        return ''
    }

    // Selling is what a membership buys; buying never needs one. The menu
    // buttons already check this, but they are only buttons -- without the
    // check here a free account reaches the listing form by typing the URL.
    if (requireMembership && (!userData.membership || userData.membership === 'free')) {
        return <Navigate to="/plans" replace={true} />
    }

    return (
        <Layout>
            {element}
        </Layout>
    );
};

export default PrivateRoute;